export default {
  users: (state = [], action) => {
    switch (action.type) {
      case 'setUsers':
        return action.payload;

      default:
        return state;
    }
  },
};
